import { FeelSubscriptionJoin, FeelSubscriptionJoinSuccess, FeelSubscriptionJoinError } from './infrastructure/state/subscription/feel-subscription.actions';
import { selectFeelSubscriptionError, selectFeelSubscriptionLoading } from './infrastructure/state/subscription/feel-subscription.selector';

export { FeelSubscriptionPublicPorts as FeelSubscriptionFeaturePublicApi } from './infrastructure/ports/feel-subscription.ports';

// #region FEEL SUBSCRIPTION
export const FeelSubscriptionFeaturePublicActions = {
    FeelSubscriptionJoin,
    FeelSubscriptionJoinSuccess,
    FeelSubscriptionJoinError,
};

export const FeelSubscriptionFeaturePublicSelectors = {
    selectFeelSubscriptionLoading,
    selectFeelSubscriptionError,
};
// #endregion
